export const ADVISER_CAMPUS_LOCATIONS = ['CLAYTON', 'PENINSULA'];
